import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router';
import { APP_NAME } from '../../shared/brand';
import { BrandMark } from './BrandMark';

/** Header and footer for pages a signed-out visitor can read. */
export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="mkt">
      <a href="#main" className="sr-only">
        Skip to content
      </a>
      <header className="mkt-bar">
        <Link to="/" className="brand" aria-label={`${APP_NAME} home`}>
          <BrandMark /> {APP_NAME}
        </Link>
        <nav className="mkt-bar__nav" aria-label="Account">
          <NavLink to="/about" className={({ isActive }) => `mkt-bar__text${isActive ? ' is-active' : ''}`}>
            About
          </NavLink>
          <Link to="/signin" className="btn btn--ghost btn--sm">
            Log in
          </Link>
        </nav>
      </header>
      <main id="main" className="mkt__main">
        {children}
      </main>
      <footer className="mkt-foot">
        <div className="mkt-foot__inner">
          <Link to="/" className="brand mkt-foot__brand">
            <BrandMark /> {APP_NAME}
          </Link>
          <p className="tiny faint mkt-foot__tag">Weigh food in grams. Weigh in daily.</p>
          <nav className="mkt-foot__nav" aria-label="Footer">
            <NavLink to="/about" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
              About
            </NavLink>
            <Link to="/signin">Sign up</Link>
            <Link to="/signin">Log in</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
